import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import * as i18n from "util/i18n";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import SolicitAvalSummaryBody from "./components/Summary";

const SolicitAvalSummaryPage = () => {
    const { echeqsToDoActions, beneficiary, echeckTicket } = useSelector((state) => state.echecks);
    const documentArr = beneficiary?.document?.split(" ");
    let dcumentType;
    let dcumentnumber;
    if (documentArr) {
        [dcumentType, dcumentnumber] = documentArr;
    }
    const avalCaracter = i18n.get(`forms.inputFile.massivePayments.total`);
    const data = {
        amount: {
            currency: echeqsToDoActions?.echeq?.emisor_moneda,
            quantity: echeqsToDoActions?.echeq?.monto,
        },
        numeroEcheq: echeqsToDoActions?.echeq?.cheque_numero,
        montoTotal: echeqsToDoActions?.echeq?.monto,
        curency: echeqsToDoActions?.echeq?.emisor_moneda,
        idEcheq: echeqsToDoActions?.echeq?.cheque_id,
        document: beneficiary?.document,
        avalista: beneficiary?.reference,
        domicilio: echeqsToDoActions?.echeq?.adress,
        caracterAval: avalCaracter,
        fechaEmision: echeqsToDoActions?.echeq?.fecha_emision,
        fechaPago: echeqsToDoActions?.echeq?.fecha_pago,
        concepto: echeqsToDoActions?.echeq?.cheque_concepto,
        motivoPago: echeqsToDoActions?.echeq?.cheque_motivo_pago,
        idCheque: echeqsToDoActions?.echeq?.cheque_id,
        emailAval: echeqsToDoActions?.echeq?.email,
        mailMessageAval: echeqsToDoActions?.echeq?.emailText,
        aval: {
            aval_nombre: beneficiary?.reference,
            aval_caracter: avalCaracter,
            aval_domicilio: echeqsToDoActions?.echeq?.adress,
            aval_documento_tipo: dcumentType,
            aval_documento: dcumentnumber,
            aval_importe_avalado: echeqsToDoActions?.echeq?.monto,
            aval_sujeto_avalado: beneficiary?.reference,
        },
        echeqsToDoActions,
        beneficiary,
        idTransaction: echeqsToDoActions?.idTransaction,
    };
    useConfirmTransaction(data, echeckTicket, "echecks/aval/solicit");
    return (
        <>
            <Notification scopeToShow="echecks/aval/confirm" />
            <ResponsiveHeader id="echecks.solicit.aval" />
            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id="echecks.summary.confirm.aval" />
                    </h2>
                    <SolicitAvalSummaryBody
                        numeroEcheq={echeqsToDoActions?.echeq?.cheque_numero}
                        montoTotal={echeqsToDoActions?.echeq?.monto}
                        curency={echeqsToDoActions?.echeq?.emisor_moneda}
                        idEcheq={echeqsToDoActions?.echeq?.cheque_id}
                        document={beneficiary?.document}
                        avalista={beneficiary?.reference}
                        domicilio={echeqsToDoActions?.echeq?.adress}
                        fechaEmision={echeqsToDoActions?.echeq?.fecha_emision}
                        fechaPago={echeqsToDoActions?.echeq?.fecha_pago}
                        concepto={echeqsToDoActions?.echeq?.cheque_concepto}
                        caracterAval={avalCaracter}
                        motivoPago={echeqsToDoActions?.echeq?.cheque_motivo_pago}
                        emailAval={echeqsToDoActions?.echeq?.email}
                        mailMessageAval={echeqsToDoActions?.echeq?.emailText}
                    />
                    <GeneralCredentialForm
                        transactionData={data}
                        action={echeckActions.solicitAval}
                        idActivity="echeq.aval.solicitar"
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default SolicitAvalSummaryPage;
